import { ChangeEvent } from "react";
import { BaseProps } from "../../utils/interfaces";

interface Validation {
    message: string;
    match: boolean;
}
export interface InputProps extends BaseProps {
    type?: InputType;
    value?: any;
    min?: number;
    max?: number;
    name: string;
    onChange?: ((event: ChangeEvent<HTMLInputElement>) => void) ;
    onBlur?: ((event: KeyboardEvent) => void);
    onKeyUp?: ((event: KeyboardEvent) => void);
    onFocus?: ((event: FocusEvent) => void);
    label?: string;
    labelHidden?: boolean;
    id?: string;
    validation?: Validation[];
}

export enum InputType {
    Text = 'text',
    Number = 'number',
    Date = 'date',
    Tel = 'tel',
    Email = 'email',
    Type = 'type'
}